import React, { useRef, useState, useCallback, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { isIOS, isMobile, isTablet } from 'react-device-detect';
import { useHistory } from 'react-router-dom';

import { RowColum, ContentsArea, MediaQuery } from '../Common';
import { BoxInImage, BoxOver, TopDesignTitle, TopDesignInfo } from '../HomePage';

import apiClient from '../../_utils/axios';
import Store from 'store';
import testimgs from '../../assets/testimgs';
import { useHomePageContext } from '../../context/HomePageContext';
import { S3_URL } from '../../libs/common';
import { getCurrentLang, getStringByLang } from '../../libs/lang';

const isMobileView = isMobile && !(isIOS && isTablet);

export const TopDesigner = ({ mainresponsive, setStateAsync }) => {
  const { state } = useHomePageContext();
  const [topDesignIndex, setTopDesignIndex] = useState(0);
  const [data, setData] = useState([]);
  const topCarousel = useRef(null);
  const history = useHistory();

  const getTopDesigner = async () => {
    try {
      const res = await apiClient.get(`/web/top/designer`);
      if (res) {
        setData(res.data);
      }
    } catch (error) {
      console.error('Failed to fetch new design list:', error);
    }
  };

  useEffect(() => {
    getTopDesigner();
  }, []); // Runs once when the component mounts

  const handleOnDesignSlideChange = (event) => {
    const { item } = event;
    setTopDesignIndex(item);
    setStateAsync('topDesignIndex', item);
  };

  const onTopDesignClick = useCallback((index) => {
    if (topCarousel.current) {
      topCarousel.current.slideTo(index);
    }
  }, []);

  const indicatorStyles = {
    height: 8,
    display: 'inline-block',
    margin: '0 8px',
    cursor: 'pointer',
    zIndex: 99,
  };

  const renderDesignDot = useCallback(() => {
    return Array(data.length)
      .fill()
      .map((_, i) =>
        topDesignIndex === i ? (
          <div
            key={'head' + i}
            style={{
              ...indicatorStyles,
              width: '4vw',
              borderRadius: 100,
              backgroundColor: 'rgb(255, 255, 255, 0.6)',
              backgroundSize: '8vw 8px',
            }}
          />
        ) : (
          <div
            key={'head' + i}
            style={{
              ...indicatorStyles,
              width: 8,
              borderRadius: 100,
              backgroundColor: 'rgb(255, 255, 255, 0.6)',
              height: 8,
            }}
            onClick={() => onTopDesignClick(i)}
          />
        ),
      );
  }, [topDesignIndex, data, onTopDesignClick]);

  const onViewDesign = (id) => {
    history.push({
      // pathname: `/design/${id}/all`,
      pathname: `/designer/shop/${id}`,
    });
  };

  const currentTitle = getStringByLang(
    state.config.main_title_5_en,
    state.config.main_title_5_en,
    state.config.main_title_5_jp,
  );

  return (
    <RowColum
      style={{
        height: 400,
        marginTop: '6vw',
        backgroundColor: '#f1f1f1',
        position: 'relative',
      }}
    >
      <BoxInImage
        style={{
          opacity: 0.03,
          backgroundImage: `url(${testimgs.topdesigner_bg})`,
        }}
      />
      <BoxOver style={{ flexDirection: 'row' }}>
        <ContentsArea
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <AliceCarousel
            ref={topCarousel}
            disableButtonsControls={true}
            disableDotsControls={true}
            responsive={mainresponsive}
            controlsStrategy="alternate"
            onInitialized={handleOnDesignSlideChange}
            onSlideChanged={handleOnDesignSlideChange}
            onResized={handleOnDesignSlideChange}
          >
            {data.map((item, index) => (
              <TopDesignTitle key={'top' + index} title={currentTitle}>
                <TopDesignInfo
                  photoimg={S3_URL(item.profile_img)}
                  name={item.nickname}
                  country={item.register_country}
                  destxt={item.seller_accounts.introduce}
                  onView={() => onViewDesign(item.seller_accounts.seller_id)}
                />
              </TopDesignTitle>
            ))}
          </AliceCarousel>
          <div
            style={{
              position: 'absolute',
              bottom: -30,
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {renderDesignDot()}
          </div>
        </ContentsArea>
      </BoxOver>
    </RowColum>
  );
};

export default TopDesigner;
